import { NavigateFunction } from 'react-router-dom'
import { resolveIndustryPath } from '../services/apis/industry'

export const CLASSIFICATION_FIELD_CODES = {
    macroEconomicSector: 1,
    sector: 2,
    industryType: 3,
    industry: 4,
} as const

export type ClassificationFieldCode = keyof typeof CLASSIFICATION_FIELD_CODES

export const isClassificationFieldCode = (fieldCode: string): fieldCode is ClassificationFieldCode =>
    fieldCode in CLASSIFICATION_FIELD_CODES

export const buildIndustryPath = (segments: string[]) =>
    `/industries/${segments.join('/')}`

const pathCache = new Map<string, string[]>()

export const getIndustrySlugPathSegments = async (securityCode: string): Promise<string[]> => {
    const cached = pathCache.get(securityCode)
    if (cached) return cached

    const response = await resolveIndustryPath(securityCode)
    const segments = [...response.slugPathSegments]
    if (segments.length > 0) {
        pathCache.set(securityCode, segments)
    }
    return segments
}

export const navigateToIndustryLevel = async (
    securityCode: string,
    fieldCode: string,
    navigate: NavigateFunction,
) => {
    if (!isClassificationFieldCode(fieldCode)) return

    const depth = CLASSIFICATION_FIELD_CODES[fieldCode]
    const segments = await getIndustrySlugPathSegments(securityCode)

    if (!segments.length) return
    navigate(buildIndustryPath(segments.slice(0, depth)))
}
